import React from 'react';

interface DateBadgeProps {
  date: string | Date;
  size?: number;
}

export default function DateBadge({ date, size = 16 }: DateBadgeProps) {
  const eventDate = new Date(date);
  const day = eventDate.getDate();
  const month = eventDate.toLocaleString('default', { month: 'short' });

  return (
    <div className='flex h-16 w-16 items-center justify-center rounded-md bg-white-filled-default p-2'>
      <div className='flex-col items-center justify-center'>
        <p className='text-center text-xl font-bold text-black-filled-default'>
          {day}
        </p>
        <p className='text-md text-center text-black-filled-default'>{month}</p>
      </div>
    </div>
  );
}
